module.exports = __webpack_public_path__ + "img/financial-assistance2.d0c2b5aa.png";